import { createTheme } from '@mui/material/styles';
import { teal } from '@mui/material/colors';
const theme = createTheme({
    palette: {
        primary: {
            main: teal[500],
        },
    },
    typography: {

        h1: {
            color: '#212529',
            fontSize: '1.9rem',
            lineHeight: 1.2
        },
        h2: {
            width: '100%',
            color: teal[500],
            fontSize: '1.2rem',
            fontWeight: 400,
            textTransform: 'uppercase',
            paddingLeft: 20,
            paddingRight: 20,
            paddingBottom: 20,
            paddingTop: 0
        },
        h3: {
            fontSize: '140%',
            fontWeight: 400
        },
        h5: {
            fontSize: '110%',
            fontWeight: 700
        },
        h7: {
            fontSize: '105%',
            fontWeight: 500
        },
        body2: {
            color: '#212529',
            textTransform: 'uppercase',
            fontWeight: 300
        },
        body3: {
            color: teal[500],
            fontSize: '1.1rem',
            fontWeight: 600
        },
        body4: {
            color: '#333',
            fontWeight: 400
        }
    },
    components: {
        MuiIcon: {
            styleOverrides: {
                root: {
                    boxSizing: 'content-box',
                    padding: 6,
                    fontSize: '.75rem',
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&.small': {
                        padding: 0
                    }
                }
            }
        }
    }
});
export default theme;